import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApolloLink } from '@apollo/client/core';
import { Observable } from 'rxjs';

/**
 * HTTP Interceptor to add an Authorization header to all outgoing
 * request.
 */
@Injectable({
  providedIn: 'root'
})
export class ApiKeyHeaderInterceptor implements HttpInterceptor {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public static API_KEY_COOKIE_KEY: string = 'apiKey';

  /**
   * Stores the API key which should be added to all outgoing requests.
   */
  private static apiKey: string = '';

  /**
   * Set the API Key which should be used as Authorization token.
   *
   * @param apiKey The API Key to use for Authorization
   */
  public static withApiKey(apiKey: string) {
    ApiKeyHeaderInterceptor.apiKey = apiKey;
    return ApiKeyHeaderInterceptor;
  }

  /**
   * Adds the Authorization header using the given API key.
   *
   * @param request The original outgoing request
   * @param next The next HTTP handler to call with the original or modified request
   */
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const newRequest = request.clone({
      setHeaders: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Authorization: 'ApiKey ' + ApiKeyHeaderInterceptor.apiKey,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'X-Api-Key': ApiKeyHeaderInterceptor.apiKey
      },
      withCredentials: true
    });
    // Pass the cloned request instead of the original request to the next handle
    return next.handle(newRequest);
  }

  /**
   * Provides a HttpLink for Apollo, which adds the Authorization headers
   * to outgoing requests.
   */
  public getAuthLink(): ApolloLink {
    return new ApolloLink((operation, forward) => {
      // Use the setContext method to set the HTTP headers.
      operation.setContext({
        headers: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          Authorization: 'ApiKey ' + ApiKeyHeaderInterceptor.apiKey,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'X-Api-Key': ApiKeyHeaderInterceptor.apiKey
        }
      });

      // Call the next link in the middleware chain.
      return forward(operation);
    });
  }
}
